var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useRef } from "react";
import Button from "../Button";
/**
 * Simple input type="file" component that is represented using a Button.
 */
function FileInputButton(_a) {
    var { onChange, isLoading, accept, multiple, children } = _a, buttonProps = __rest(_a, ["onChange", "isLoading", "accept", "multiple", "children"]);
    const inputRef = useRef(null);
    const handleClick = useCallback(() => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }, []);
    const handleChange = useCallback(() => {
        var _a;
        const files = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files;
        if (files && onChange) {
            onChange(files);
        }
    }, [onChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: inputRef, type: "file", accept: accept, multiple: multiple, style: { display: "none" }, onChange: handleChange }),
        React.createElement(Button, Object.assign({ isLoading: isLoading, onClick: handleClick }, buttonProps), children)));
}
FileInputButton.displayName = "FileInputButton";
export default FileInputButton;
//# sourceMappingURL=FileInputButton.js.map